export const planetData = [
    {
        name: 'moon',
        detail: 'See our planet as you’ve never seen it before. A perfect relaxing trip away to help regain perspective and come back refreshed. While you’re there, take in some history by visiting the Luna 2 and Apollo 11 landing sites.',
        distance: '384,400',
        travelTime: '3 DAYS',
        img: '/assets/destination/moon.png'
    },
    {
        name: 'mars',
        detail: 'Don’t forget to pack your hiking boots. You’ll need them to tackle Olympus Mons, the tallest planetary mountain in our solar system. It’s two and a half times the size of Everest!',
        distance: '225 MIL.',
        travelTime: '9 MONTHS',
        img: '/assets/destination/mars.png'
    },
    {
        name: 'europa',
        detail: 'The smallest of the four Galilean moons orbiting Jupiter, Europa is a winter lover’s dream. With an icy surface, it’s perfect for a bit of ice skating, curling, hockey, or simple relaxation in your snug wintery cabin.',
        distance: '628 MIL.',
        travelTime: '3 YEARS',
        img: '/assets/destination/europa.png'
    },
    {
        name: 'titan',
        detail: 'The only moon known to have a dense atmosphere other than Earth, Titan is a home away from home (just a few hundred degrees colder!). As a bonus, you get striking views of the Rings of Saturn.',
        distance: '1.6 BIL.',
        travelTime: '7 YEARS',
        img: '/assets/destination/titan.png'
    }
]
export const crewMem = [
    {
        id:'1',
        name: 'DOUGLAS HURLEY',
        detail: 'Douglas Gerald Hurley is an American engineer, former Marine Corps pilot and former NASA astronaut. He launched into space for the third time as commander of Crew Dragon Demo-2.',
        designation: 'COMMANDER',
        img: '/assets/crew/douglas.png'
    },
    {
        id:'2',
        name: 'MARK SHUTTLEWORTH',
        detail: 'Mark Richard Shuttleworth is the founder and CEO of Canonical, the company behind the Linux-based Ubuntu operating system. Shuttleworth became the first South African to travel to space as a space tourist.',
        designation: 'MISSION SPECIALIST',
        img: '/assets/crew/mark.png'
    },
    {
        id:'3',
        name: 'VICTOR GLOVER',
        detail: 'Pilot on the first operational flight of the SpaceX Crew Dragon to the International Space Station. Glover is a commander in the U.S. Navy where he pilots an F/A-18.He was a crew member of Expedition 64, and served as a station systems flight engineer.',
        designation: 'PILOT',
        img: '/assets/crew/victor.png'
    },
    {
        id:'4',
        name: 'ANOUSHEH ANSARI',
        detail: 'Anousheh Ansari is an Iranian American engineer and co-founder of Prodea Systems. Ansari was the fourth self-funded space tourist, the first self-funded woman to fly to the ISS, and the first Iranian in space.',
        designation: 'FLIGHT ENGINEER',
        img: '/assets/crew/anousheh.png'
    }
]
export const vehData = [
    {
        id:'1',
        name: 'LAUNCH VEHICLE',
        detail: "A launch vehicle or carrier rocket is a rocket-propelled vehicle used to carry a payload from Earth's surface to space, usually to Earth orbit or beyond. Our WEB-X carrier rocket is the most powerful in operation. Standing 150 metres tall, it's quite an awe-inspiring sight on the launch pad!",
        img: '/assets/tech/launchVehicle.jpg'
    },
    {
        id:'2',
        name: 'SPACEPORT',
        detail: 'A spaceport or cosmodrome is a site for launching (or receiving) spacecraft, by analogy to the seaport for ships or airport for aircraft. Based in the famous Cape Canaveral, our spaceport is ideally situated to take advantage of the Earth’s rotation for launch.',
        img: '/assets/tech/spaceport.jpg'
    },
    {
        id:'3',
        name: 'SPACE CAPSULE',
        detail: "A space capsule is an often-crewed spacecraft that uses a blunt-body reentry capsule to reenter the Earth's atmosphere without wings. Our capsule is where you'll spend your time during the flight. It includes a space gym, cinema, and plenty of other activities to keep you entertained.",
        img: '/assets/tech/spaceCapsule.jpg'
    }
]